<template>
    <div class="logo">
      <img src="../assets/img/logo-locker-company-neg.svg" alt="Logo" :width="inPosMode() ? 110 : 85" v-if="inDarkMode()" />
      <img src="../assets/img/logo-locker-company.svg" alt="Logo" :width="inPosMode() ? 110 : 85" v-else />
    </div>
</template>

<script>
    import posMixin from '../mixins/posMixin'
    import darkModeMixin from '../mixins/darkModeMixin'

    export default {
        mixins: [posMixin, darkModeMixin]
    }
</script>
